module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc9-3cfdbea6e60cba9e553f16fdb3ab6f03.jpg";